<template>
  <div>
    <task-detail @onSave="taskSaved" @onDelete="fetchDetail()" />

    <div class="radius">
      <content-loading v-if="isLoading" />
      <div class="mb-4" v-if="!goBackDisabled">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
          <path
            d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087"
            stroke="#FF7C48"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div v-if="!isLoading && policy" class="d-flex flex-wrap justify-content-start">
        <div class="pcard d-flex flex-column mr-4 w-100">
          <div class="d-flex flex-row justify-content-end">
            <!-- <div class="text-right" v-b-tooltip.hover :title="$t('policy.acceptance.rejected')"> -->
            <!-- <i class="iconoir-edit" @click="edit(policy._id)"></i> -->
            <div class="ml-4 mr-2">
              <policy-periodical-select :disabled="isEditDisabled" @onSave="periodEdited($event, policy)" :policy="policy"></policy-periodical-select>
            </div>
            <div class="action font-size-24 ml-1 mr-1" @click="redirectToRelatedFiles(policy)" v-on:click.stop v-b-tooltip.hover :title="$t('file-manager.view-related-files')">
              <i class="iconoir-page hand"></i>
            </div>
            <div>
              <div class="text-right ml-2">
                <i
                  v-if="!['COMPLETED', 'NOT_APPLICABLE'].includes(policy.status)"
                  class="iconoir-prohibition text-danger hand h3"
                  v-b-tooltip.hover
                  :title="$t('policy.out-of-scope')"
                  @click="deletePolicy(policy)"
                ></i>
              </div>
              <div class="text-right">
                <i
                  v-if="'NOT_APPLICABLE' == policy.status"
                  class="iconoir-prohibition text-success hand h3"
                  v-b-tooltip.hover
                  :title="$t('policy.applicable')"
                  @click="revertDeleted(policy)"
                ></i>
              </div>
            </div>

            <!-- </div> -->
          </div>

          <div class="row">
            <!-- <policy-status-select :policy="policy" @onSelect="paginate" /> -->

            <div class="col-md-12">
              <div class="pcard--title text-break">
                <h4>{{ $t("policy.name") }}</h4>
                {{ policy.name | translate }} <br />
                <h4 class="mt-3">{{ $t("policy-category.text") }}</h4>
                <small><policy-category-badge :policy="policy"/></small>
              </div>
              <div>
                <div class="" style="gap: 1rem;">
                  <div v-if="policy.description" class="pcard--description">
                    <div class="pcard--title">{{ $t("common.description") }}</div>
                    <div class="pcard--description--text">
                      {{ policy.description | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!------<pre>{{ policy }}</pre>------>

          <h4>{{ $t("policy.related-compliances") }}</h4>
          <table class="table table-bordered table-striped bg-white">
            <thead class="bg-secondary text-white">
              <tr>
                <td class="w-10">{{ $t("policy.compliance") }}</td>
                <td class="w-10">{{ $t("policy-group.text") }}</td>
                <td class="w-10">{{ $t("policy.no") }}</td>
                <td class="w-10">{{ $t("policy.level") }}</td>
                <td class="w-60">{{ $t("policy.definition") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="compliance in policy.compliances" :key="compliance._id">
                <td>{{ compliance.product }}</td>
                <td>{{ compliance.policyGroup.name | translate }}</td>
                <td>{{ compliance.policyNo }}</td>
                <td>{{ compliance.policyLevel }}</td>
                <td>{{ compliance.policyDefinition | translate }}</td>
              </tr>
            </tbody>
          </table>

          <h4>{{ $t("policy.related-risks") }}</h4>
          <div v-if="!isEditDisabled">
            <div class="pcard--title" style="margin-bottom: 0.8rem;">
              <span
                class="add-button hand"
                @click="
                  policy.showRiskLinkPanel = true;
                  $forceUpdate();
                "
              >
                {{ $t("common.link-with") }}
                <i class="iconoir-plus font-size-24"></i>
              </span>
            </div>

            <b-row v-if="policy.showRiskLinkPanel" class="mb-3">
              <b-col>
                <filter-select :id="'riskFilter'" :ref="'riskFilter'" :placeholder="$t('risk.text')" @filter="onRiskSearch" @changed="onRiskSelect($event)" />
              </b-col>
              <b-col md="3">
                <b-button v-if="!isEditDisabled" @click="linkWithRisk(policy)" :disabled="!selectedRisk" class="btn-block btn-success">{{ $t("common.link-with") }}</b-button>
              </b-col>
            </b-row>
          </div>
          <table class="table table-bordered table-striped bg-white">
            <thead class="bg-secondary text-white">
              <tr>
                <td class="w-10">{{ $t("risk.name") }}</td>
                <td class="w-10">{{ $t("risk.threat-definition.text") }}</td>
                <td class="w-10">{{ $t("risk.weakness-definition.text") }}</td>
                <td class="w-5"></td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="risk in policy.risks" :key="risk._id">
                <td>{{ risk.name | translate }}</td>
                <td>{{ displayDefinitions(risk.threats) }}</td>
                <td>{{ displayDefinitions(risk.weaknesses) }}</td>
                <td>
                  <div v-if="!isEditDisabled">
                    <i @click="unlinkRisk(risk, policy)" class="bx bx-trash-alt text-danger hand mr-4 float-left d-inline-block" v-b-tooltip.hover :title="$t('common.delete')"></i>
                    <i @click="redirectToRisk(risk._id)" class="bx bx-search text-primary hand" v-b-tooltip.hover :title="$t('risk.view')"></i>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <h4>{{ $t("policy.related-asset-groups") }}</h4>
          <table class="table table-bordered table-striped bg-white">
            <thead class="bg-secondary text-white">
              <tr>
                <td class="w-10">{{ $t("asset-group.no") }}</td>
                <td class="w-10">{{ $t("asset-group.name") }}</td>
                <td class="w-10">{{ $t("asset-group.degree-of-criticality") }}</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="assetGroup in policy.assetGroups" :key="assetGroup._id">
                <td>{{ assetGroup.no }}</td>
                <td>{{ assetGroup.name | translate }}</td>
                <td>{{ assetGroup.criticalityLevel }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="!policy.assetGroups || policy.assetGroups.length == 0">
            <p class="ml-1">{{ $t("policy.asset-group-not-exists") }}</p>
          </div>

          <h4 v-if="policy.complianceStatuses.length > 0 && !isAllComplianceStatusesCompleted(policy)">{{ $t("policy.compliance-acceptance.text") }}</h4>
          <p v-if="policy.complianceStatuses.length == 0 && policy.compliances.some((i) => i.product == 'BGYS')" class="text-danger">
            <span>{{ $t("policy.bgys-action-plan-info") }}</span>
          </p>
          <div class="card card-body" v-if="policy.complianceStatuses.length > 0 && !isAllComplianceStatusesCompleted(policy)">
            <div
              :id="'accordion_' + complianceStatus._id"
              :visible="complianceStatusesVisible[complianceStatus._id]"
              role="tabpanel"
              v-for="(complianceStatus, index) in policy.complianceStatuses"
              :key="complianceStatus.definitionId"
            >
              <div @click="selectElement(complianceStatus)">
                <div class="mt-2">
                  <div class="row bg-soft-primary pt-2 pb-2">
                    <div class="col-md-8">
                      <a v-b-toggle="'accordion_' + complianceStatus._id" class="text-dark" href="javascript: void(0);">
                        <div v-if="complianceStatus.assetGroup">
                          <b v-if="complianceStatus.assetGroup"> {{ complianceStatus.assetGroup.name | translate }}</b>

                          <span v-if="complianceStatus.assetGroup && complianceStatus.assetGroup.criticalityLevel"> ({{ complianceStatus.assetGroup.criticalityLevel }})</span>
                        </div>
                        <div v-else>
                          <b>{{ complianceStatus.products.join(", ") }}</b>
                        </div>
                      </a>
                    </div>

                    <div class="col-md-4 text-left"></div>
                  </div>
                  <b-collapse :id="'accordion_' + complianceStatus._id" :visible="index == 0">
                    <div class="row ">
                      <div class="col-md-12">
                        <PolicyComplianceStatusSelect
                          :ref="complianceStatus.definitionId"
                          :disabled="isEditDisabled"
                          :policy="policy"
                          :complianceStatus="complianceStatus"
                          @onSelect="onComplienceStatusUpdated($event, policy, complianceStatus)"
                        />
                      </div>
                    </div>
                    <div>
                      <!-- <PolicyComplianceStatusDescription :disabled="isEditDisabled" :policy="policy" :compliance="complianceStatus" /> -->
                    </div>
                    <h5 class="mt-5">{{ $t("policy.action-plan-related-risks") }}</h5>

                    <b-row v-if="complianceStatus.showTaskLinkPanel" class="mb-3">
                      <b-col md="9">
                        <filter-select
                          :id="'taskFilter' + complianceStatus.definitionId"
                          :ref="'taskFilter' + complianceStatus.definitionId"
                          :placeholder="$t('task.name')"
                          @filter="onTaskSearch"
                          @changed="onTaskSelect($event, complianceStatus)"
                        />
                      </b-col>
                      <b-col md="3">
                        <b-button @click="linkWithTask(complianceStatus)" :disabled="!complianceStatus.selectedTask" class="btn-block btn-success">{{
                          $t("common.link-with")
                        }}</b-button>
                      </b-col>
                    </b-row>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="d-flex flex-row">
                          <div class="mr-4">
                            <strong>{{ $t("policy.action-plan.no") }}: {{ complianceStatus.no }}</strong>
                          </div>
                          <div class="mr-4">
                            <strong>
                              {{ $t("policy.action-plan.started-date") }}: <span v-if="complianceStatus.startedDate">{{ complianceStatus.startedDate | date }}</span></strong
                            >
                          </div>
                          <div>
                            <strong
                              >{{ $t("policy.action-plan.donedate") }}: <span v-if="complianceStatus.acceptanceDate">{{ complianceStatus.acceptanceDate | date }}</span></strong
                            >
                          </div>
                        </div>
                        <div v-if="showComplianceActions(complianceStatus)" class="pcard--title mt-2" style="margin-bottom: 0.8rem;">
                          <span> {{ $t("policy.related-tasks") }}</span>
                          <span v-if="policy.status == 'IN_PROGRESS'" class="add-button d-inline hand ml-3" @click="createTask(complianceStatus)">
                            <i class="iconoir-plus font-size-24 align-middle"></i>{{ $t("task.create") }}/ {{ $t("common.link-with") }}</span
                          >
                          <span
                            v-if="policy.status == 'IN_PROGRESS'"
                            class="add-button d-inline hand ml-3"
                            @click="
                              complianceStatus.showTaskLinkPanel = true;
                              $forceUpdate();
                            "
                          >
                            <i class="iconoir-plus font-size-24 align-middle"></i> {{ $t("policy.link-with-existing-task") }}
                          </span>
                          <span v-if="policy.status == 'WAITING_FOR_ASSESSMENT'" class="add-button d-inline hand ml-3 text-left">
                            <policy-task-definition-form
                              class="d-inline "
                              store="organizationPolicy"
                              styles="d-inline"
                              labelStyle="text-main "
                              :submitPrevent="true"
                              :label="$t('policy.add-task-definition')"
                              @saved="saveTaskDefinition($event, complianceStatus)"
                            />
                          </span>
                        </div>
                        <div
                          v-if="
                            complianceStatus.acceptance == 'UNWORKED' &&
                              (!complianceStatus.tasks || complianceStatus.tasks.length == 0) &&
                              complianceStatus.taskDefinitions.length > 0
                          "
                        >
                          <div v-for="taskDefinition in complianceStatus.taskDefinitions" :key="'policy-task-def-' + taskDefinition._id">
                            <task-item
                              :task="taskDefinition"
                              :isItDefinition="true"
                              @editClicked="editTaskDefinition"
                              @removeClicked="removeTaskDefinition($event, complianceStatus)"
                            />
                          </div>
                        </div>

                        <div v-if="complianceStatus.tasks && complianceStatus.tasks.length > 0">
                          <div v-for="task in complianceStatus.tasks" :key="'policy-task-' + task._id" class="hand">
                            <task-item
                              :task="task"
                              :unlink="showComplianceActions(complianceStatus)"
                              @unlinked="unlinkTask(task, complianceStatus)"
                              @click="openTaskDetailModal(task)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>

          <b-card no-body class="custom-card shadow-none custom-accordion" v-if="policy.history && policy.history.length > 0">
            <b-card-header header-tag="header" role="tab" class="bg-danger">
              <a v-b-toggle="'accordion_history'" class="text-dark" href="javascript: void(0);">
                <h5 class="text-dark">
                  {{ $t("policy.action-plan.completed") }}
                </h5>
              </a>
            </b-card-header>
            <b-collapse id="accordion_history" :visible="false" style="background-color: #F5F7F9;">
              <div class="d-flex flex-wrap mb-4 mt-4 pl-4 pr-4">
                <div style="width: 100%; gap: 1rem;">
                  <div class="edit-card" style="overflow-x: auto;">
                    <table class="table table-bordered table-striped">
                      <thead class="bg-secondary text-white">
                        <tr>
                          <th class="w-15">{{ $t("policy.action-plan.no") }}</th>
                          <th>{{ $t("policy.action-plan.account") }}</th>
                          <th>{{ $t("policy.action-plan.started-date") }}</th>
                          <th>{{ $t("policy.action-plan.donedate") }}</th>
                          <th></th>
                          <!-- <th style="width: 150px;">{{ $t("asset-group.name") }}</th> -->
                          <!-- <th style="width: 450px;">{{ $t("task.name") }}</th> -->
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="item in policy.history" :key="item._id">
                          <td>
                            {{ item.complianceStatus.no }}
                          </td>
                          <td>
                            <span v-if="item.account">
                              {{ item.account }}
                            </span>
                          </td>
                          <td>
                            {{ item.complianceStatus.startedDate | date }}
                          </td>
                          <td>{{ item.at | date }}</td>
                          <td class="text-center">
                            <i @click="showActionPlanDetail(item)" class="bx bx-search text-primary hand" v-b-tooltip.hover :title="$t('policy.action-plan.detail')"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>

          <b-card no-body class="custom-card shadow-none custom-accordion" v-if="policy.applicableHistory && policy.applicableHistory.length > 0">
            <b-card-header header-tag="header" role="tab" class="bg-danger">
              <a v-b-toggle="'accordion_applicable_history'" class="text-dark" href="javascript: void(0);">
                <h5 class="text-dark">
                  {{ $t("policy.applicable-history") }}
                </h5>
              </a>
            </b-card-header>
            <b-collapse id="accordion_applicable_history" :visible="false" style="background-color: #F5F7F9;">
              <div class="d-flex flex-wrap mb-4 mt-4 pl-4 pr-4">
                <div style="width: 100%; gap: 1rem;">
                  <div class="edit-card" style="overflow-x: auto;">
                    <table class="table table-bordered table-striped">
                      <thead class="bg-secondary text-white">
                        <tr>
                          <th class="w-15">{{ $t("policy.applicable-change-at") }}</th>
                          <th>{{ $t("policy.applicable-change-status") }}</th>
                          <th>{{ $t("policy.applicable-change-account") }}</th>
                          <th>{{ $t("policy.applicable-change-description") }}</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="item in policy.applicableHistory" :key="item._id">
                          <td>
                            {{ item.at | date }}
                          </td>
                          <td>
                            {{ item.status == "NOT_APPLICABLE" ? $t("policy.out-of-scope") : $t("policy.applicable") }}
                          </td>
                          <td>
                            <span v-if="item.account">
                              {{ item.account }}
                            </span>
                          </td>
                          <td>
                            {{ item.description | translate }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-collapse>
          </b-card>
          <b-modal centered hide-footer size="xl" id="action-plan-detail-modal" :title="$t('policy.action-plan.detail')">
            <div v-if="selectedHistoryItem">
              <div class="row">
                <div class="col-md-3">
                  <div class="mr-4">
                    <b>{{ $t("policy.action-plan.no") }}:</b> <span class="ml-2">{{ this.selectedHistoryItem.complianceStatus.no }}</span>
                  </div>

                  <div class="mt-4">
                    <b>{{ $t("asset-group.text") }}:</b
                    ><span v-if="this.selectedHistoryItem.assetGroup">
                      <span class="ml-2">{{ this.selectedHistoryItem.assetGroup.name | translate }}</span>
                    </span>
                  </div>
                </div>

                <div class="col-md-3">
                  <b> {{ $t("policy.action-plan.started-date") }}:</b>
                  <span v-if="this.selectedHistoryItem.complianceStatus.startedDate">
                    <span class="ml-2">{{ this.selectedHistoryItem.complianceStatus.startedDate | date }}</span>
                  </span>

                  <div class="mt-4">
                    <b>{{ $t("policy.compliance-acceptance.text") }}:</b> {{ acceptanceText(this.selectedHistoryItem.complianceStatus.acceptance) }}
                  </div>
                </div>
                <div class="col-md-3">
                  <b>{{ $t("policy.action-plan.donedate") }}:</b
                  ><span v-if="this.selectedHistoryItem.complianceStatus.acceptanceDate">
                    <span class="ml-2">{{ this.selectedHistoryItem.complianceStatus.acceptanceDate | date }}</span>
                  </span>

                  <div class="mt-4">
                    <b>{{ $t("policy.compliance-acceptance.target") }}:</b> {{ acceptanceText(this.selectedHistoryItem.complianceStatus.targetAcceptance) }}
                  </div>
                </div>
                <div class="col-md-3">
                  <b>{{ $t("policy.action-plan.account") }}:</b
                  ><span v-if="this.selectedHistoryItem.account">
                    <span class="ml-2">{{ this.selectedHistoryItem.account }}</span>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="alert alert-warning mt-2" v-if="this.selectedHistoryItem.message">
                    <!-- <h5 class="mt-4">{{ $t("policy.action-plan.tasks") }}</h5> -->
                    <p>{{ this.selectedHistoryItem.message | translate }}</p>
                  </div>

                  <h5 class="mt-4">{{ $t("policy.action-plan.tasks") }}</h5>

                  <div v-if="this.selectedHistoryItem.tasks.length == 0">
                    <empty width="100px">
                      <h5 class="text-center">{{ $t("policy.action-plan.task-empty") }}</h5>
                    </empty>
                  </div>
                </div>
              </div>

              <div class="row">
                <div v-for="task in this.selectedHistoryItem.tasks" :key="'policy-task-' + task._id" class="hand col-md-12">
                  <task-item :showAssignee="true" :showDates="true" :task="prepareHistoryTaskForDetailView(task)" @click="openTaskDetailModal(task)" />
                </div>
              </div>
            </div>
          </b-modal>

          <PolicyDeleteModal @hidden="deleteModalHidden" :policy="policy" :id="'policy-delete-modal' + policy._id" />

          <div class="text-right" v-if="!isEditDisabled && policy.status == 'WAITING_FOR_ASSESSMENT' && policy.complianceStatuses.length > 0">
            <sweet-button @click="save(policy._id)" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
              {{ $t("policy.action-plan.start") }}
            </sweet-button>
          </div>

          <div class="text-right" v-if="policy.status == 'COMPLETED' || policy.status == 'WAITING_FOR_PERIOD'">
            <sweet-button @click="moveToWaitinForAssessmenet(policy._id)" type="submit" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
              {{ $t("policy.action-plan.re-apply") }}
            </sweet-button>
          </div>
        </div>
      </div>
    </div>
    <!------------>
  </div>
</template>

<script>
import TaskReadMode from "../../components/client/task/task-read-mode.vue";
import PolicyCategoryBadge from "./component/policy-category-badge";
import PolicyComplianceStatusDescription from "./component/policy-compliance-status-description";
import PolicyComplianceStatusSelect from "./component/policy-compliance-status-select";
import PolicyDeleteModal from "./component/policy-delete-modal";
import PolicyDetail from "./component/policy-detail";
import PolicyPeriodicalSelect from "./component/policy-periodical-select";
import PolicyStatusSelect from "./component/policy-status-select";

import PolicyTaskDefinitionForm from "./component/policy-task-definition-form";
import RiskItem from "./component/risk-item";

export default {
  props: ["product", "id", "goBackDisabled"],
  components: {
    TaskReadMode,
    PolicyStatusSelect,
    PolicyPeriodicalSelect,
    PolicyComplianceStatusSelect,

    PolicyComplianceStatusDescription,
    PolicyTaskDefinitionForm,
    RiskItem,
    PolicyCategoryBadge,
    PolicyDetail,
    TaskReadMode,
    PolicyDeleteModal,
  },

  data() {
    return {
      selectedRisk: undefined,
      complianceStatusesVisible: {},
      form: undefined,
      selectedTask: undefined,
      selectedComplianceStatus: undefined,
      selectedHistoryItem: undefined,
    };
  },
  computed: {
    isEditDisabled() {
      return ["COMPLETED", "NOT_APPLICABLE"].includes(this.policy.status);
    },
    policy() {
      return this.$store.getters["organizationPolicy/policy"];
    },
    isLoading() {
      return this.$store.getters["organizationPolicy/isLoading"];
    },
    hasUnworkedPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },
  },
  watch: {
    policy: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form = {
            ...this.prepareFormForEdit(v),
          };
        }
      },
    },
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    displayDefinitions(array) {
      if (!array || !array.length) {
        return "";
      }
      return array.map((i) => i.name[this.currentLanguage]).join(", ");
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { policy: item._id, policyName: item.name?.[this.currentLanguage] } });
    },
    prepareHistoryTaskForDetailView(task) {
      let data = { ...task };
      data.assignee = { name: data.assignee };
      return { ...data };
    },
    showActionPlanDetail(item) {
      this.selectedHistoryItem = item;
      this.$bvModal.show("action-plan-detail-modal");
    },
    isAllComplianceStatusesCompleted(policy) {
      return (
        ["WAITING_FOR_PERIOD", "COMPLETED"].includes(policy.status) &&
        policy.complianceStatuses.every(
          (complianceStatus) =>
            complianceStatus.acceptance != "UNWORKED" && complianceStatus.targetAcceptance != "UNWORKED" && complianceStatus.acceptance == complianceStatus?.targetAcceptance
        )
      );
    },

    acceptanceText(value) {
      if (value == "UNWORKED") {
        return this.$t("policy.compliance-acceptance.unworked");
      } else if (value == "COMPLETELY") {
        return this.$t("policy.compliance-acceptance.completely");
      } else if (value == "PARTIAL") {
        return this.$t("policy.compliance-acceptance.partial");
      } else if (value == "MOSTLY") {
        return this.$t("policy.compliance-acceptance.mostly");
      } else if (value == "NEVER") {
        return this.$t("policy.compliance-acceptance.never");
      } else if (value == "NOT_APPLICABLE") {
        return this.$t("policy.compliance-acceptance.not-applicable");
      }

      return this.$t("policy.compliance-acceptance.unworked");
    },

    goBack() {
      const path = `/${this.currentProduct && this.currentProduct != "PLATFORM" ? this.currentProduct.toLowerCase() : "organization"}/policy`;
      this.$router.push(path);
    },
    fetchDetail() {
      const id = this.id || this.$route.params.id;
      this.$store.dispatch("organizationPolicy/fetchDetail", id);
    },
    icon(product) {
      if (product == "KVKK") {
        return "/icons/kvkk-active.svg";
      }
      if (product == "GDPR") {
        return "/icons/gdpr-active.svg";
      }
      if (product == "DDO") {
        return "/icons/ddo-active.svg";
      }
      if (product == "BGYS") {
        return "/icons/bgys-active.svg";
      }
    },
    periodEdited(event, policy) {
      this.fetchDetail();
    },
    createTask(complianceStatus) {
      this.selectedComplianceStatus = complianceStatus;

      this.$store.commit("task/showTaskCreateModal", true);
    },

    async saveTaskDefinition(taskDefinition, complianceStatus) {
      try {
        if (!taskDefinition) {
          return this.fetchDetail();
        }
        const cs = complianceStatus;
        if (!taskDefinition?._id) {
          taskDefinition._id = "id" + new Date().getTime();

          cs.taskDefinitions.push(taskDefinition);
        } else {
          const index = cs.taskDefinitions.findIndex((item) => item.id === taskDefinition.id);
          if (index !== -1) {
            cs.taskDefinitions[index] = taskDefinition;
          }
        }

        const payload = { id: this.policy._id, ...cs, conditionDefinitionId: cs.definitionId };
        await this.$store.dispatch("organizationPolicy/updateComplianceStatus", payload);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.fetchDetail();
      }
    },
    async taskSaved(task) {
      try {
        this.selectedComplianceStatus.selectedTask = task;
        if (task && task?._id) {
          this.linkWithTask(this.selectedComplianceStatus, false);
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.fetchDetail();
      }
      // this.$refs["taskFilter" + this.selectedComplianceStatus.definitionId]?.map((i) => i.reset());
      //burada tedbirin önceki statusu ile sonraki statusu değişti ise paginate çağırılsın şeklinde yapılabilir.
    },
    showComplianceActions(compliance) {
      return compliance.acceptance != compliance.targetAcceptance || compliance.acceptance == "UNWORKED";
    },
    async save() {
      try {
        const payload = [];
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }

        for (const cs of this.policy.complianceStatuses) {
          const item = this.$refs?.[cs.definitionId]?.[0]?.getFormData();
          if (item.acceptance == item.targetAcceptance && item.acceptance != "UNWORKED" && !item.acceptanceDate) {
            this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("policy.acceptance-date-missing", { no: item.no }) });
            return;
          }
          payload.push(item);
        }

        await this.$store.dispatch("organizationPolicy/complianceStatusBulkUpdate", payload);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        await this.fetchDetail();
      }
      //this.goBack();
    },
    async moveToWaitinForAssessmenet(id) {
      try {
        await this.$store.dispatch("organizationPolicy/changePolicyStatus", id);
        this.$toast.success(this.$t("common.success"));
        await this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    redirectToRisk(id) {
      if (!id) {
        return;
      }
      const policyId = this.id || this.$route.params.id;
      this.$router.push(`/${this.currentProduct.toLowerCase()}/risk-detail/${id}?goBackPath=${this.currentProduct.toLowerCase()}/policy-detail/${policyId}`);
    },

    selectElement(complianceStatus, index) {
      const id = complianceStatus._id;
      this.policy.complianceStatuses.forEach((status) => {
        if (status._id !== id) {
          this.$set(this.complianceStatusesVisible, status._id, false);
        }
      });

      this.$set(this.complianceStatusesVisible, id, !this.complianceStatusesVisible[id]);

      this.selectedComplianceStatus = complianceStatus;
    },
    openTaskDetailModal(task) {
      this.$store.commit("task/showTaskDetailModal", true);
      this.$bvModal.hide();
      this.$root.$emit("bv::hide::modal");
      this.$bvModal.hide("policy-detail-modal");

      return this.$store.dispatch("task/fetchDetail", task._id);
    },

    OpenTaskReadModeModal(task) {
      this.$store.commit("task/task", task);
      this.$bvModal.show("task-read-mode-modal");
    },

    create() {
      this.$store.commit("organizationPolicy/isCreating", true);
    },
    saveDescription() {
      try {
        this.$store.dispatch("organizationPolicy/updateComplianceStatusDescription", true);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async deletePolicy(policy) {
      try {
        policy.status = "NOT_APPLICABLE";
        this.$bvModal.show("policy-delete-modal" + policy._id);
      } catch (error) {}
    },
    async deleteModalHidden() {
      this.goBack();
    },
    async revertDeleted(policy) {
      try {
        policy.status = "WAITING_FOR_ASSESMENT";
        this.$bvModal.show("policy-delete-modal" + policy._id);
      } catch (error) {}
    },

    async unlinkRisk(risk, policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        // if (this.isEditing) {
        await this.$store.dispatch("organizationPolicy/removePolicyRiskRelation", {
          policyId: policy._id,
          riskId: risk._id,
        });
        // }

        policy.risks = policy.risks.filter((i) => i._id != risk._id);
        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithRisk(policy) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        //   if (this.isEditing) {
        const response = await this.$store.dispatch("organizationPolicy/addPolicyRiskRelation", {
          policyId: policy._id,
          riskId: this.selectedRisk._id,
        });

        policy.risks.push(response.data.risk);
        this.selectedRisk = undefined;
        policy.showRiskLinkPanel = false;

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));

        //this.$store.dispatch("organizationPolicy/fetchDetail", this.policy._id);
        // } else {
        //   if (!this.form.risks.find((i) => i._id == this.selectedRisk._id)) {
        //     this.form.risks.push({ _id: this.selectedRisk._id, name: this.selectedRisk.name });
        //   }
        // }
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onRiskSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationRisk/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, status: { value: { $ne: "RATING" }, isObject: true }, products: { value: { $in: [this.product] }, isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },

    onRiskSelect(risk) {
      this.selectedRisk = risk;
      this.$forceUpdate();
    },

    async unlinkTask(task, complianceStatus) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("task/removeTaskPolicyRelation", {
          policyId: this.policy._id,
          taskId: task._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });

        complianceStatus.tasks = complianceStatus.tasks.filter((i) => i._id != task._id);

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithTask(complianceStatus, confirm = true) {
      if (confirm) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }
      try {
        const response = await this.$store.dispatch("task/addTaskPolicyRelation", {
          policyId: this.policy._id,
          taskId: complianceStatus.selectedTask._id,
          complianceStatusDefinitionId: complianceStatus.definitionId,
        });
        //await this.$store.dispatch("organizationPolicy/fetchDetail", this.policy._id);
        // this.paginate();
        complianceStatus.tasks.push(response.data.task);
        complianceStatus.selectedTask = undefined;
        complianceStatus.showTaskLinkPanel = false;

        this.$forceUpdate();

        if (confirm) {
          this.$toast.success(this.$t("common.success"));
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onTaskSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchOrganizationTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onTaskSelect(task, complianceStatus) {
      complianceStatus.selectedTask = task;
      this.$forceUpdate();
    },

    async onComplienceTargetStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.targetAcceptance = definition;
      this.fetchDetail();
    },
    async onComplienceStatusUpdated(value, policy, complianceStatus) {
      complianceStatus.acceptance = value.definition;
      this.fetchDetail();
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },

    editTaskDefinition(task) {
      this.$store.commit(`organizationPolicy/editedTask`, { ...task });
      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task`);
    },

    async removeTaskDefinition(taskDefinition, complianceStatus) {
      try {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
        const cs = complianceStatus;
        complianceStatus.taskDefinitions = complianceStatus.taskDefinitions.filter((i) => i._id != taskDefinition._id);

        const payload = { id: this.policy._id, ...cs, conditionDefinitionId: cs.definitionId };
        await this.$store.dispatch("organizationPolicy/updateComplianceStatus", payload);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.fetchDetail();
      }
    },
    async downloadExcel() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        if (this.workedFilter == "WAITING_FOR_ASSESSMENT") {
          payload.status = "WAITING_FOR_ASSESSMENT";
        } else if (this.workedFilter == "IN_PROGRESS") {
          payload.status = "IN_PROGRESS";
        } else if (this.workedFilter == "WAITING_FOR_PERIOD") {
          payload.status = "WAITING_FOR_PERIOD";
        } else if (this.workedFilter == "COMPLETED") {
          payload.status = "COMPLETED";
        } else if (this.workedFilter == "NOT_APPLICABLE") {
          payload.status = "NOT_APPLICABLE";
        }

        const { data: file } = await this.$store.dispatch(`organizationPolicy/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-policy.scss";

.card-body .card-header {
  background-color: #ebedf9 !important;
}

.card-header[role="tab"],
.card-header .accordion-list {
  background-color: #e2e0ff !important;
}

.card-header[role="tab"].bg-success,
.card-header.bg-success .accordion-list {
  background-color: #eaf5ff !important;
}
.card-header[role="tab"].bg-primary,
.card-header.bg-success .accordion-list {
  background-color: #aedbf6 !important;
}
.card-header[role="tab"].bg-danger,
.card-header.bg-success .accordion-list {
  background-color: #f9dfd4 !important;
}
.custom-radius {
  border-radius: 0.625rem;
}
.custom-card {
  border-radius: 0.625rem;
  padding: 0.5rem;

  margin-bottom: 1.5rem;
}
.legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.box {
  width: 20px;
  height: 20px;
}
.bg-light-warning {
  background-color: #ffbd8a;
}
</style>
